/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown>, position: NonNullable<unknown>, total: NonNullable<unknown> }} Practice_Drag_EndInputs */



/**
* | output |
* | --- |
* | "{title} dropped in position {position} of {total}." |
*
* @param {Practice_Drag_EndInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_drag_end = /** @type {((inputs: Practice_Drag_EndInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Drag_EndInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.title} neergezet op plaats ${i?.position} van ${i?.total}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.title} déposé en position ${i?.position} sur ${i?.total}.`)
	return /** @type {LocalizedString} */ (`${i?.title} dropped in position ${i?.position} of ${i?.total}.`)
});